import ACheckbox from './a-checkbox.vue';

export default ACheckbox;